import { useSelector, useDispatch } from "react-redux";
import {
  selectNotification,
  setCurrentPageNotification,
  setNextPageNotification,
} from "../redux/notificationSlice";
import { defaultErrorMessage } from "../Common/UserException";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { cleanup } from "@testing-library/react";

const [success, info, warning, error] = ["success", "info", "warning", "error"];

export { success, info, warning, error };

export function getNotificationForError(errorObject) {
  let friendlyErrorMessage = defaultErrorMessage;
  if (
    typeof errorObject === "object" &&
    typeof errorObject.message === "string"
  ) {
    friendlyErrorMessage = errorObject.message;
  } else if (typeof errorObject === "string") {
    friendlyErrorMessage = errorObject;
  }
  return { type: error, message: friendlyErrorMessage };
}

export default function Alert() {
  const [tick, setTick] = useState(0);
  const history = useHistory();
  const pathname =
    (history && history.location && history.location.pathname) || "";
  useEffect(() => {
    displayNextPageNotification();
  }, [pathname]);
  useEffect(() => {
    let mounted = true;
    setTimeout(() => mounted && setTick(tick + 1), 1000);
    return () => (mounted = false);
  }, [tick]);

  const dispatch = useDispatch();
  const notification = useSelector(selectNotification);
  const expirationTime = notification && notification.expiration;
  const isExpired = !expirationTime
    ? false
    : expirationTime < new Date().getTime();
  const message = notification.message || null;
  const showMessage = message && !isExpired;
  const type = notification.type;
  let alertClass = "";
  switch (type) {
    case success:
      alertClass = "alert-success";
      break;
    case warning:
      alertClass = "alert-warning";
      break;
    case error:
      alertClass = "alert-danger";
      break;
    case info:
    default:
      alertClass = "alert-info";
      break;
  }
  const dismissAlert = () => {
    dispatch(setCurrentPageNotification({ message: null, type: null }));
  };
  const displayNextPageNotification = () => {
    const { nextPageMessage: nextMessage, nextPageMessageType: nextType } =
      notification;
    dispatch(setNextPageNotification({ message: null, type: null }));
    dispatch(
      setCurrentPageNotification({ message: nextMessage, type: nextType })
    );
  };
  return (
    showMessage && (
      <div className={`alert ${alertClass}`} role="alert">
        {message}
        <button
          type="button"
          aria-label="Dismiss alert"
          className="close"
          onClick={() => dismissAlert()}
        >
          &times;
        </button>
      </div>
    )
  );
}
